import React, { useState } from "react";
import "./index.scss";
import logo from "../../assets/logo.png";
import close from "../../assets/close.png";
import AppButton from "../appButton";
import { useNavigate } from "react-router-dom";

const ModalOverlay = () => {
  const [isOpen, setIsOpen] = useState(true);

  const closeModal = () => {
    setIsOpen(false);
  };
  const navigate = useNavigate();

  return (
    isOpen && (
      <div className="modal-overlay">
        <div className="modal-content">
          <div className="row w-100 justify-content-between">
            <div className="col-lg-5">
              <img
                src={logo} // Replace with your image URL
                alt="Donation"
                className="modal-image logo-modal"
              />
            </div>
            <div className="col-lg-5">
              <button className="close-button" onClick={closeModal}>
                <img
                  src={close} // Replace with your image URL
                  alt="Donation"
                  className="modal-image"
                />
              </button>
            </div>{" "}
          </div>

          <div className="modal-text">
            <div className="row w-100 justify-content-between">
              {" "}
              <div className="col-lg-5"></div>
              <div className="col-lg-5 mobile-text">
                {" "}
                <h2>DONNER C’EST RÉSISTER</h2>
              </div>
            </div>
            <div className="row   h-100 justify-content-center align-items-end">
              <h2 className="display-mobile">DONNER C’EST RÉSISTER</h2>
              <div className="col-lg-5  d-flex  justify-content-center mt-5">
                <AppButton
                  text="Faire un don"
                  color="orange"
                  className="width_mobile width-total1 "
                  size="large"
                  onClick={() => {
                    navigate("/faire-don");
                    window.scrollTo(0, 0);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default ModalOverlay;
